const state = {
    measure:{
        maxLength:1000,
        overrideMessage: 'Cuidado con sobrepasar el límite permitido de caracteres'
    },
    locale: 'es'
}

const mutations = {
    setLocale(state, locale){
        
        state.locale = locale;
        localStorage.setItem('locale', locale);

    }
}
const getters = {
    getMeasureMaxLength(base){
        return base.measure.maxLength;
    },
    getMeasureOverrideMessage(base){
        return base.measure.overrideMessage;
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    getters
}